// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bfk_a bhj_wh bhj_sq bhj_xj"};